<template>
  <InsuranceIntermediaryDesktop v-if="isDesktop" />
  <InsuranceIntermediaryMobile v-else />
</template>

<script>
import { mapGetters } from 'vuex';
import InsuranceIntermediaryDesktop from './insurance-intermediary-desktop';
import InsuranceIntermediaryMobile from './insurance-intermediary-mobile';

export default {
  components: { InsuranceIntermediaryDesktop, InsuranceIntermediaryMobile },
  computed: {
    ...mapGetters('layoutModule', ['isDesktop']),
  }
};
</script>
